import { ro } from './ro';
import { en } from './en';
import { de } from './de';
import { fr } from './fr';
import { es } from './es';
import { it } from './it';

export const translations = {
  ro,
  en,
  de,
  fr,
  es,
  it
} as const;

/**
 * Helper function to replace placeholders in translation strings
 * @param str - String with placeholders like {{key}}
 * @param params - Object with replacement values
 * @returns String with placeholders replaced
 */
export const interpolate = (str: string, params: Record<string, string | number> = {}): string => {
  return str.replace(/\{\{(\w+)\}\}/g, (match, key) => {
    return params[key] !== undefined ? String(params[key]) : match;
  });
};
